module.exports = __webpack_public_path__ + "img/goals2.08c12a3f.svg";